<ion-content>
  <div class="page-wrapper">

    <div class="page-header">
      <h1>{{ 'logs.title' | translate }}</h1>
      <ion-button fill="outline" size="small" (click)="load()">
        <ion-icon name="refresh-outline" slot="start"></ion-icon>
        {{ 'logs.refresh' | translate }}
      </ion-button>
    </div>

    @if (isLoading) {
    <div class="center-row"><ion-spinner></ion-spinner></div>
    } @else if (loadError) {
    <div class="center-row">
      <p>{{ 'logs.loadError' | translate }}</p>
      <ion-button fill="outline" size="small" (click)="load()">{{ 'common.retry' | translate }}</ion-button>
    </div>
    } @else if (entries.length === 0) {
    <div class="center-row"><p>{{ 'logs.empty' | translate }}</p></div>
    } @else {
    <ion-card class="usage-card">
      <ion-card-content>
        <div class="usage-table">
          <div class="usage-table__row usage-table__row--head">
            <span>{{ 'tokenDetail.usage.method' | translate }}</span>
            <span>{{ 'tokenDetail.usage.path' | translate }}</span>
            <span>{{ 'tokenDetail.usage.status' | translate }}</span>
            <span>{{ 'logs.token' | translate }}</span>
            <span>{{ 'tokenDetail.usage.timestamp' | translate }}</span>
          </div>
          @for (entry of entries; track entry.tokenId + entry.occurredAt + entry.path) {
          <div class="usage-table__row">
            <span class="method-badge" [ngClass]="methodBadgeClass(entry.method)">{{ entry.method }}</span>
            <code class="usage-table__path">{{ entry.path }}</code>
            <ion-badge [color]="statusColor(entry.statusCode)">{{ entry.statusCode }}</ion-badge>
            <a class="usage-table__token" [routerLink]="['/tokens', entry.tokenId]">{{ entry.tokenName }}</a>
            <span class="usage-table__time">{{ entry.occurredAt | date:'short' }}</span>
          </div>
          }
        </div>
      </ion-card-content>
    </ion-card>
    }
  </div>
</ion-content>
